<template>
  <div class="card card-height">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th>Date</th>
          <th>Invoice Number</th>
          <th>Invoice Type</th>
          <th>Order Type</th>
          <th>Client Name</th>
          <th>Business Unit</th>
          <th>Sales Person</th>
          <th class="text-right">Invoice Amount</th>
          <th class="text-right">VAT Amount</th>
          <th class="text-right">Total Amount</th>
          <th class="text-right">Bill Sett. Discount</th>
          <th class="text-right">Adjusted Amount</th>
          <th class="text-right">Net Collection</th>
          <th class="text-right">Due Amount</th>
          <th class="text-center">Payment Status</th>
          <th>Action</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td>{{ item.date }} </td>
          <td>{{ item.bill_number }}</td>
          <td>{{ item.invoice_type }}</td>
          <td>{{ item.sales_order_master ? item.sales_order_master.sale_type_title : '' }}</td>
          <td>{{ item.contact_name }}</td>
          <td>{{ item.business_name }}</td>
          <td>{{ item.sr_name }}</td>
          <td class="text-right">{{ item.subtotal_amount }}</td>
          <td class="text-right">{{ item.vat_amount }}</td>
          <td class="text-right">{{ item.total_amount }}</td>
          <td class="text-right">{{ item.discount }}</td>
          <td class="text-right">{{ item.adjusted_amount - item.discount }}</td>
          <td class="text-right">{{ item.paid_amount }}</td>
          <td class="text-right">{{ getTotalDue(item) }}</td>
          <td class="text-center">{{ item.payment_status }}</td>
          <td>
            <button @click="onClickAddNewButton(item)" title v-if="item.payment_status === 'DUE'" class="btn btn-outline-primary btn-sm  ">
              <i class="fas fa-plus"></i>
              Money Receipt
            </button>
          </td>
        </tr>
        <tr v-if="currentPage === lastPage">
          <td colspan="7"></td>
          <td class="text-right"> {{ totalValue && totalValue.total_subtotal_amount }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_vat_amount }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_sum_amount }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_discount_amount }}</td>
          <td class="text-right"> {{ totalValue && getTotalAdjustedAmount(tableItems) }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_paid_amount }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_due_amount }}</td>
          <td> </td>
          <td> </td>
        </tr>
        </tbody>
      </table>
      <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";

const props = defineProps({
  tableItems: {
    type: Array,
  },
  currentPage: Number,
  lastPage: Number,
  totalValue: Object,
})
const route = useRoute()
const router = useRouter()
const onClickAddNewButton = (item) =>  {
  let query = {
   saleMasterId:item.id,
   contactId:item.contact_profile_id,
   type:'pending-money-receipt',
   start:route.query.start,
   end:route.query.end,
   page:route.query.page,
  }
  return router.push({name: 'sales-invoice-receipt', params: route.params, query: query})
}

const getTotalDue = (item) => {
  return parseFloat(item.total_amount) - (parseFloat(item.paid_amount) + parseFloat(item.adjusted_amount))
}

const getTotalAdjustedAmount = (items) => {
  return items.reduce((total, saleMaster) => total + (saleMaster.adjusted_amount - saleMaster.discount), 0);
}

</script>

<style scoped>
.mr-5 {
  margin-right: 5px;
}
.action-th {
  width: 20%;
  text-align: center;
}
.name {
  width: 15%;
}
.action{
  text-align: center;
}

</style>